import { VFC } from 'react';
import { ProgressProps } from 'antd';
import { theme } from 'consts/themeBase';
import { StyledStepsProgressBar } from './components/StyledProgressBar';

interface StepsProgressBarProps extends ProgressProps {
  progressStep: number;
  steps: number;
}

export const StepsProgressBar: VFC<StepsProgressBarProps> = ({ steps, progressStep }) => (
  <StyledStepsProgressBar
    percent={(progressStep / steps) * 100}
    showInfo={false}
    steps={steps}
    strokeColor={theme.colors.main}
    strokeWidth={8}
    type="line"
  />
);
